
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quote/list/[id]",
      function () {
        return require("private-next-pages/quote/list/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quote/list/[id]"])
      });
    }
  